import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsMxExtra from '@angular/common/locales/extra/es-MX';

registerLocaleData(localeEsMx, 'es-MX', localeEsMxExtra);

import { CarouselModule } from 'ngx-owl-carousel-o';
import { LoadingSpinnerComponent } from './components/common/loading-spinner/loading-spinner.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxCaptchaModule } from 'ngx-captcha';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { ReactiveFormsModule } from '@angular/forms';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PreloaderComponent } from './components/common/preloader/preloader.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { VacantListComponent } from './components/pages/vacant-and-proyects/vacant-and-proyects.component';
import { CandidatesComponent } from './components/pages/candidates/candidates.component';
import { HomeComponent } from './components/pages/home/home.component';
import { AboutComponent } from './components/pages/about/about.component';
import { JobListComponent } from './components/pages/job-list/job-list.component';
import { JobDetailsComponent } from './components/pages/job-details/job-details.component';
import { PostAJobComponent } from './components/pages/post-a-job/post-a-job.component';
import { CandidateDetailsComponent } from './components/pages/candidate-details/candidate-details.component';
import { PricingComponent } from './components/pages/pricing/pricing.component';
import { CompanyDetailsComponent } from './components/pages/company-details/company-details.component';
import { LoginComponent } from './components/pages/login/login.component';
import { CreateAccountComponent } from './components/pages/create-account/create-account.component';
import { ProfileComponent } from './components/pages/profile/profile.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { ChangePasswordComponent } from './components/pages/change-password/change-password.component';
import { HomeLoginComponent } from './components/pages/home-login/home-login.component';
import { PasswordProfileComponent } from './components/pages/profile/password-profile/password-profile.component';
import { EducationCandidateComponent } from './components/pages/profile/education-candidate/education-candidate.component';
import { ExperienceCandidateComponent } from './components/pages/profile/experience-candidate/experience-candidate.component';
import { AbilityCandidateComponent } from './components/pages/profile/ability-candidate/ability-candidate.component';
import { LanguageCandidateComponent } from './components/pages/profile/language-candidate/language-candidate.component';
import { NetworkSocialCandidateComponent } from './components/pages/profile/network-social-candidate/network-social-candidate.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PasswordComponent } from './components/pages/change-password/password/password.component';
import { CertificadeCandidateComponent } from './components/pages/profile/certificado-candidate/certificate-candidate.component';
import { VerifyAccountComponent } from './components/pages/verify-account/verify-account/verify-account.component';
import { CandidateFeaturedComponent } from './components/pages/candidate-featured/candidate-featured.component';
import { VerificationCodeComponent } from './components/pages/verify-account/verify-account/verification-code/verification-code.component';
import { SoloNumerosDirective } from './directives/soloNumeros.directive';
// import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgModule } from '@angular/core';
import { IntlTelInputDirective } from './directives/intl-tel-input.directive';
import { CvVaultComponent } from './components/pages/cv-vault/cv-vault.component';
import { MisSuscripcionesComponent } from './components/pages/mis-suscripciones/mis-suscripciones.component';
import { AdminScraperComponent } from './components/pages/admin-scraper/admin-scraper.component';
import { AdminVacantesComponent } from './components/pages/admin-vacantes/admin-vacantes.component';
import { AdminConfigComponent } from './components/pages/admin-config/admin-config.component';
import { AdminUsuariosComponent } from './components/pages/admin-usuarios/admin-usuarios.component';
import { AlertsPanelComponent } from './components/pages/alerts-panel/alerts-panel.component';
import { StripeSuccessComponent } from './components/pages/stripe-success/stripe-success.component';
import { FreeOnboardingComponent } from './components/pages/free-onboarding/free-onboarding.component';
import { CompletarEmpresaComponent } from './components/pages/completar-empresa/completar-empresa.component';
import { AdminSuscripcionesComponent } from './components/pages/admin-suscripciones/admin-suscripciones.component';
import { AdminStripeComponent } from './components/pages/admin-stripe/admin-stripe.component';
import { AdminSocialComponent } from './components/pages/admin-social/admin-social.component';
import { AdminGuruMatchComponent } from './components/pages/admin-gurumatch/admin-gurumatch.component';
import { AppDatePipe } from './pipes/app-date.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { TimezoneSelectorComponent } from './components/common/timezone-selector/timezone-selector.component';
import { TermsModalComponent } from './components/common/terms-modal/terms-modal.component';
import { TerminosComponent } from './components/pages/terminos/terminos.component';

// import { ModalModule } from 'ngb-modal';
// import { Ng2TelInputModule } from 'ng2-tel-input';


@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    AboutComponent,
    JobListComponent,
    
    JobDetailsComponent,
    PostAJobComponent,
    CandidateDetailsComponent,
    PricingComponent,
    CompanyDetailsComponent,
    LoginComponent,
    CreateAccountComponent,
    ProfileComponent,
    ErrorComponent,
    ContactComponent,
    VacantListComponent,
    HomeLoginComponent,
    CandidatesComponent,
    ChangePasswordComponent,
    PasswordComponent,
    PasswordProfileComponent,
    EducationCandidateComponent,
    ExperienceCandidateComponent,
    CertificadeCandidateComponent,
    AbilityCandidateComponent,
    LanguageCandidateComponent,
    NetworkSocialCandidateComponent,
    VerifyAccountComponent,
    CandidateFeaturedComponent,
    VerificationCodeComponent,
    SoloNumerosDirective,
    IntlTelInputDirective,
    CvVaultComponent,
    MisSuscripcionesComponent,
    AdminScraperComponent,
    AdminVacantesComponent,
    AdminConfigComponent,
    AdminSocialComponent,
    AdminUsuariosComponent,
    AlertsPanelComponent,
    FreeOnboardingComponent,
    StripeSuccessComponent,
    CompletarEmpresaComponent,
    AdminSuscripcionesComponent,
    AdminStripeComponent,
    AdminGuruMatchComponent,
    AppDatePipe,
    StripHtmlPipe,
    TimezoneSelectorComponent,
    TermsModalComponent,
    TerminosComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    LoadingSpinnerComponent,
    CarouselModule,
    FormsModule,
    HttpClientModule,
    // ModalModule,
    //  Ng2TelInputModule,
    NgxCaptchaModule,
    NgxPaginationModule,
    NgxScrollTopModule,
    ReactiveFormsModule,
    NgbModule,
    // NgxIntlTelInputModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-MX' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
